import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const STATUSES = ["requested", "confirmed", "completed", "cancelled"];

export default function Consultations() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/consultations");
      setItems(data);
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const update = async (id, patch) => {
    try {
      await api.patch(`/admin/consultations/${id}`, patch);
      toast.success("Updated");
      await load();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  return (
    <div className="p-8 md:p-10" data-testid="admin-consultations">
      <p className="overline mb-2">Consultations</p>
      <h1 className="text-3xl font-bold tracking-tight mb-8" style={{ fontFamily: "'Outfit', sans-serif" }}>Consultation requests</h1>

      <div className="bg-white border border-zinc-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-zinc-50">
            <tr className="text-left">
              {["Name", "Company", "Topic", "Preferred times", "Duration", "Status", "Requested"].map((h) => (
                <th key={h} className="px-4 py-3 font-mono text-[10px] uppercase tracking-widest text-zinc-500">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} className="px-4 py-10 text-center text-zinc-500 font-mono">Loading…</td></tr>
            ) : items.length === 0 ? (
              <tr><td colSpan={7} className="px-4 py-10 text-center text-zinc-500 font-mono">No consultations yet.</td></tr>
            ) : items.map((c) => (
              <tr key={c.id} className="border-t border-zinc-200 hover:bg-zinc-50" data-testid={`consult-row-${c.id}`}>
                <td className="px-4 py-3">
                  <div className="font-medium">{c.lead_name}</div>
                  <div className="text-xs text-zinc-500">{c.lead_email}</div>
                </td>
                <td className="px-4 py-3 text-zinc-700">{c.company || "—"}</td>
                <td className="px-4 py-3 text-zinc-700">{c.topic}</td>
                <td className="px-4 py-3 text-zinc-600 text-xs">{(c.preferred_times || []).join(", ") || "—"}</td>
                <td className="px-4 py-3 font-mono text-xs">{c.duration_minutes}m</td>
                <td className="px-4 py-3">
                  <select value={c.status} onChange={(e) => update(c.id, { status: e.target.value })} className="border border-zinc-200 px-2 py-1 text-xs bg-white" data-testid={`consult-status-${c.id}`}>
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
                <td className="px-4 py-3 text-xs font-mono text-zinc-500">{c.created_at ? new Date(c.created_at).toLocaleDateString() : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
